<div class="card">
  <h6 class="mb-3" *ngIf="titulo">{{ titulo }}</h6>

  <!-- Formulário para adicionar novo mapeamento -->
  <div class="grid mb-3" *ngIf="!disabled">
    <div class="col-12 md:col-5">
      <p-floatLabel>
        <input
          pInputText
          id="campoOrigem"
          [(ngModel)]="novoMapeamento.origem"
          [style]="{'width':'100%'}"
          placeholder="Campo Origem" />
        <label for="campoOrigem">Campo Origem</label>
      </p-floatLabel>
    </div>

    <div class="col-12 md:col-1 flex align-items-center justify-content-center">
      <i class="pi pi-arrow-right text-2xl text-gray-400"></i>
    </div>

    <div class="col-12 md:col-5">
      <p-floatLabel>
        <input
          pInputText
          id="campoDestino"
          [(ngModel)]="novoMapeamento.destino"
          [style]="{'width':'100%'}"
          placeholder="Campo Destino" />
        <label for="campoDestino">Campo Destino</label>
      </p-floatLabel>
    </div>

    <div class="col-12 md:col-1 flex align-items-center">
      <button
        pButton
        icon="pi pi-plus"
        class="p-button-success"
        (click)="adicionarMapeamento()"
        [disabled]="!novoMapeamento.origem || !novoMapeamento.destino"
        pTooltip="Adicionar Mapeamento"
        tooltipPosition="top">
      </button>
    </div>
  </div>

  <!-- Tabela de mapeamentos -->
  <p-table
    [value]="mapeamentosList"
    [paginator]="false"
    styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines"
    [scrollable]="true"
    scrollHeight="300px">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 45%">Campo Origem</th>
        <th style="width: 10%" class="text-center">
          <i class="pi pi-arrow-right"></i>
        </th>
        <th style="width: 35%">Campo Destino</th>
        <th style="width: 10%" class="text-center" *ngIf="!disabled">Ações</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-mapeamento>
      <tr>
        <td>
          <span class="font-mono text-primary">{{ mapeamento.origem }}</span>
        </td>
        <td class="text-center">
          <i class="pi pi-arrow-right text-gray-400"></i>
        </td>
        <td>
          <input
            *ngIf="!disabled"
            pInputText
            [(ngModel)]="mapeamento.destino"
            (ngModelChange)="editarMapeamento(mapeamento, $event)"
            [style]="{'width':'100%'}"
            class="font-mono" />
          <span *ngIf="disabled" class="font-mono text-primary">{{ mapeamento.destino }}</span>
        </td>
        <td class="text-center" *ngIf="!disabled">
          <button
            pButton
            icon="pi pi-trash"
            class="p-button-danger p-button-text p-button-sm"
            (click)="removerMapeamento(mapeamento.origem)"
            pTooltip="Remover Mapeamento"
            tooltipPosition="top">
          </button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td [attr.colspan]="disabled ? 3 : 4" class="text-center">
          <div class="text-gray-500 py-4">
            <i class="pi pi-info-circle text-2xl mb-2"></i>
            <p>Nenhum mapeamento configurado</p>
            <p class="text-sm" *ngIf="!disabled">Adicione campos usando o formulário acima</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!-- Resumo -->
  <div class="mt-3 text-sm text-gray-600" *ngIf="mapeamentosList.length > 0">
    <i class="pi pi-info-circle mr-1"></i>
    {{ mapeamentosList.length }} campo(s) mapeado(s)
  </div>
</div>
